import { render, staticRenderFns } from "./ListClaimCourier.vue?vue&type=template&id=a3c382e2"
import script from "./ListClaimCourier.vue?vue&type=script&lang=js"
export * from "./ListClaimCourier.vue?vue&type=script&lang=js"
import style0 from "./ListClaimCourier.vue?vue&type=style&index=0&id=a3c382e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports